module.exports = __webpack_public_path__ + "images/emoji/bell.d291d02e67a99bdafc47.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bell.png
// module id = DY2I
// module chunks = 13